import { render } from "./ErrorScreen.vue?vue&type=template&id=318ba0cd"
import script from "./ErrorScreen.vue?vue&type=script&lang=ts"
export * from "./ErrorScreen.vue?vue&type=script&lang=ts"

import "./ErrorScreen.vue?vue&type=style&index=0&id=318ba0cd&lang=scss"
script.render = render

export default script